import BasicDetailsCard from '../../../../components/page/Vendor/Profile/Card/BasicDetailsCard';

interface meProps {
	slug?: string;
	Vendorme?: any;
}
export default function Profilepage({ slug, Vendorme }: meProps) {
	return (
		<>
			<BasicDetailsCard slug={slug} Vendorme={Vendorme} />
		</>
	);
}
